import { Component, OnInit, OnDestroy, ViewChild } from '@angular/core';
import { sweetAlert } from '../../../utils/swal';
import * as _ from 'underscore';
import * as moment from 'moment-timezone';
import { SocketService } from 'src/app/service/socket-service/socket-service.service';
import { Events } from 'src/app/utils/event-utils';
import { SharedDataService } from 'src/app/service/shared-service/shared-data.service';
import { DispatchCenterService } from '../../dashboard/dashboard-service/dispatch-center-service';
import { downloadFile } from 'src/app/utils/pdf-downloader';
import { urls } from 'src/app/utils/url-utils';
import { MenuService } from '../../shared/layout/menu-service/menu.service';
import { takeUntil } from 'rxjs/operators';
import { componentDestroyed } from '@w11k/ngx-componentdestroyed';
import { Cms1500Service } from 'src/app/service/cms-service/cms1500.service';
import { CsvService } from 'src/app/service/csv-service/csv.service';
import { ToastrService } from 'ngx-toastr';
import { ReportService } from '../../reports/reports-service/report.service';
import { FilterByKeyPipe } from 'src/app/pipe/list-filterbykey-pipe/list-filterbykey-pipe';
import { FilterPipe } from 'src/app/pipe/list-filter-pipe/list-filter-pipe';
import { CorporateService } from '../../corporate-user/corporate-service/corporate-service';
import { DriversService } from '../../drivers/drivers-service/drivers-service';
import { LevelOfServiceService } from '../../level-of-service/service/level-of-service.service';
import { ServiceAreasService } from '../../service-areas/service-areas-service/service-areas.service';
import { environment } from 'src/environments/environment';
import { StaffService } from '../../staffs/staff-service/staff.service';
import { AssigTripsService } from '../../assigned-trips/assigntrips-service/assigntrips-service';
import { checkRole } from 'src/app/utils/utils.common';
import { FleetService } from '../../fleet/fleet-service/fleet.service';

@Component({
  selector: 'app-trip-reports',
  templateUrl: './trip-reports.component.html',
  styleUrls: ['./trip-reports.component.css']
})
export class TripReportsComponent implements OnInit {
  dataList = [];
  filterdataList = [];
  status = "all";
  isShowAllTrips = true;
  showSlideFilter = false;
  search: any;
  componentType;
  tripIndex = -1;
  timeZone;
  settingInterval;
  secondaryCompType = null;
  user;
  selectedTrip;
  selectedTrips = [];
  orderBy = "scheduleTime";
  view = "list";
  selectedDropdownIndex: any;
  skip = 0;
  selectedTripId;
  isAllTripsSelected: boolean = false;


  selectedTripPurpose = '';
  selectedLOS = '';
  selectedSpaceType = '';
  appointmentTypes;
  selectedAptType;
  selectedServiceArea = '';
  patients;
  selectedPatient = "";
  drivers;
  selectedDriver = "";
  cooperates;
  selectedCooperate = "";

  preCooperates = {};
  preLevelOfServices = {};
  preSpaceTypes = {};
  preServiceAreas = {};
  corporateList = [];
  filteredCorporates = [];
  serviceAreaList = [];
  filteredServiceAreas = [];
  levelOfServiceList = [];
  filteredLevelOfService = [];
  spaceTypeList = [];
  filteredSpaceTypes = [];

  stationManagerList = [];
  selectedStationManager = [];
  preStaffList = {};
  tripPurposesAndAddons: any;
  subMenus: any;
  isAllowRates: boolean = false;
  preFleet = {};
  preDrivers = {};
  todayDate: any
  timeFormat: string = 'HHmm';

  constructor(
    private reportService: ReportService,
    private cms1500Service: Cms1500Service,
    private assignTripService: AssigTripsService,
    private dispatchCenterService: DispatchCenterService,
    private sharedDataService: SharedDataService,
    private socketService: SocketService,
    private menuService: MenuService,
    private csvService: CsvService,
    private toastr: ToastrService,
    private corporateService: CorporateService,
    private driverService: DriversService,
    private levelOfServiceService: LevelOfServiceService,
    private serviceArea: ServiceAreasService,
    private staffService: StaffService,
    private fleetService: FleetService,

  ) { }

  ngOnInit() {
    this.getCorporate();
    this.getLevelOfService();
    this.getSpaceTypes();
    this.getServiceAreas();
    this.getUser();
    this.listenSocket();
    this.getStaffList();
    this.getFleetList();
  }

  setTripStatus(status, isSkipCheck?) {
    if (!isSkipCheck && this.status === status) return;
    this.skip = 0;
    this.clearTrips();
    this.selectedDropdownIndex = -1;
    this.status = status;
    this.getTrips();
    this.reset();
  }

  reset() {
    this.selectedTrips = [];
    this.orderBy = "scheduleTime";
  }

  getCorporate() {
    this.corporateService
      .getCorporateUsers('active')
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(data => {
        if (data) {
          this.corporateList = data;
          this.preCooperates = data.reduce((obj, item) => (obj[item._id] = item, obj), {});
        }
      }, err => {
        sweetAlert('Error', err, 'warning', 'OK');
      });
  }


  getLevelOfService() {
    this.levelOfServiceService
      .getLevelOfServices({ status: 'active' })
      .subscribe(data => {
        if (data) {
          this.levelOfServiceList = data;
          this.preLevelOfServices = data.reduce((obj, item) => (obj[item._id] = item, obj), {});
        }
      }, err => {
        sweetAlert("Error", err, "error", "Ok");
      });
  }

  getSpaceTypes() {
    this.levelOfServiceService
      .getSpaceTypes({ status: 'active' })
      .subscribe(data => {
        if (data) {
          this.spaceTypeList = data;
          this.preSpaceTypes = data.reduce((obj, item) => (obj[item._id] = item, obj), {});
        }
      }, err => {
        sweetAlert("Error", err, "error", "Ok");
      });
  }

  getServiceAreas() {
    this.serviceArea.getServiceAreas({ status: 'active' })
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(
        (data) => {
          if (data) {
            this.serviceAreaList = data;
            this.preServiceAreas = data.reduce((obj, item) => (obj[item._id] = item, obj), {});
          }
        },
        (err) => {
          sweetAlert("Error", err, "error", "Ok");
        }
      );
  }

  getStaffList() {
    this.staffService
      .getStaffList()
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(data => {
        if (data) {
          this.preStaffList = data.reduce((obj, item) => (obj[item._id] = item, obj), {});
        }
      }, err => {
        sweetAlert('Error', err, 'warning', 'OK');
      });
  }

  getStaffRoles() {
    if (this.user && this.user.roles) {
      if (typeof this.user.roles === "string") {
        if (this.user.sRoles)
          this.subMenus = this.menuService.getTripReportSubMenu(this.user.sRoles);
        else
          this.subMenus = this.menuService.getTripReportSubMenu(this.user.roles);
      } else if (typeof this.user.roles === "object") {
        this.subMenus = this.menuService.getTripReportSubMenu(this.user.roles[0]);
      }
    }

    if (this.subMenus && this.subMenus.length) {
      if (this.subMenus[0].value === "all" && this.subMenus.length > 1)
          this.status = this.subMenus[0].value;

      this.getTrips();
    }
  }

  getUser() {
    this.sharedDataService
      .getUser()
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe((data) => {
        if (data) {
          this.timeZone = data.timeZone;
          this.user = data;
           if (this.user.timeFormat) {
            this.timeFormat = this.user.timeFormat;
          }
          this.todayDate = [
                      moment.tz(this.timeZone).startOf("day").toISOString(),
                      moment.tz(this.timeZone).endOf("day").toISOString(),
                    ];
          this.getStaffRoles();
          this.isAllowRates = checkRole(this.user);
          this.getDrivers();
        }
      });
  }

  getTrips() {
    // this.filterdataList = [];
    // this.dataList = [];
    const object = {
      isShowAllTrips: this.isShowAllTrips,
      status: this.status,
      date: this.todayDate,
      skip: this.skip,
      isRawData : true
    };
    this.assignTripService
      .getTripList(object)
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(
        (data) => {
          if (this.skip === 0) {
            this.clearTrips();
          }
          if (data && object.status === this.status) {
            this.dataList = [...data, ...this.dataList];
            this.filterdataList = this.dataList;
            this.group(true);


            if (data.length) {
              this.skip += data.length;
              this.getTrips();
            } else {
              this.skip = 0;
              this.drivers = [];
              this.stationManagerList = [];
              let cooperates = [];
              this.tripPurposesAndAddons = [];
              let levelOfServices = [];
              let spaceTypes = [];
              let serviceAreas = [];
              this.appointmentTypes = [];
              this.patients = [];
              this.dataList.forEach(trip => {

                if (trip.driver) {
                  this.drivers.push({ _id: trip.driver._id, displayName: trip.driver.displayName });
                }
                if (trip.driver && trip.driver.stationManager) {
                  this.stationManagerList.push(trip.driver.stationManager);
                }
                if (trip.cooperate) {
                  cooperates.push(trip.cooperate);
                }

                // if (trip.tripReason) {
                //   // remove the item having empty string
                //   const reasons = trip.tripReason.split(',').filter((reason) => reason !== '');
                //   if (reasons && reasons.length) {
                //     this.tripPurposesAndAddons.push(...reasons);
                //   }
                // }

                if (trip.addonServices && trip.addonServices.length) {
                  for (let addon of trip.addonServices) {
                    this.tripPurposesAndAddons.push(addon.title);
                  }
                }

                if (trip.los) {
                  levelOfServices.push(trip.los);
                }

                if (trip.spaceType) {
                  spaceTypes.push(trip.spaceType);
                }

                if (trip.tripReason) {
                  // remove the item having empty string
                  if (trip.tripReason && trip.tripReason.length) {
                    this.appointmentTypes.push(...trip.tripReason);
                  }
                }
                // const zipCode = this.extractZipCode(trip.jobOriginAddress)
                if (trip.serviceArea) {
                  serviceAreas.push(trip.serviceArea);
                }
                if (trip.priorityClient) {
                  this.patients.push({ displayName: trip.priorityClient.displayName });
                }
              });


              if (this.selectedLOS)
                levelOfServices.push(this.selectedLOS)

              if (this.selectedSpaceType)
                spaceTypes.push(this.selectedSpaceType)

              if (this.selectedServiceArea)
                serviceAreas.push(this.selectedServiceArea)

              if (this.selectedAptType)
                this.appointmentTypes.push(this.selectedAptType)

              if (this.selectedPatient)
                this.patients.push(this.selectedPatient)



              this.drivers = _.uniq(this.drivers, '_id');
              this.drivers.sort(function (a, b) {
                return a.displayName.localeCompare(b.displayName);
              });
              this.stationManagerList = _.uniq(this.stationManagerList).sort();
              cooperates = _.uniq(cooperates).sort();
              this.tripPurposesAndAddons = [...new Set(this.tripPurposesAndAddons)].sort();
              levelOfServices = _.uniq(levelOfServices).sort();
              spaceTypes = _.uniq(spaceTypes).sort();
              serviceAreas = _.uniq(serviceAreas).sort();
              this.appointmentTypes = [...new Set(this.appointmentTypes)].sort();
              this.patients = _.uniq(this.patients, 'displayName').sort();

              if (cooperates && cooperates.length) {
                this.filteredCorporates = this.corporateList.filter(c => cooperates.includes(c._id));
              }

              if (levelOfServices && levelOfServices.length) {
                this.filteredLevelOfService = this.levelOfServiceList.filter(l => levelOfServices.includes(l._id));
              }

              if (serviceAreas && serviceAreas.length) {
                this.filteredServiceAreas = this.serviceAreaList.filter(s => serviceAreas.includes(s._id));
              }

              if (spaceTypes && spaceTypes.length) {
                this.filteredSpaceTypes = this.spaceTypeList.filter(s => spaceTypes.includes(s._id));
              }

              if (this.status === 'unassigned') {
                this.selectedDriver = "";
                this.selectedStationManager = [];
              }
            }
          }
          this.filterTripsByModel();
        }, err => {
          sweetAlert('Error', err, 'warning', 'OK');
        });
  }

  clearTrips() {
    this.skip = 0;
    this.filterdataList = [];
    this.dataList = [];
  }

  listenSocket() {
    this.socketService
      .addListener(Events.GET_ASSIGN_TRIP_ETA)
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe((data) => {

        if (data.success) {
          if (this.filterdataList && this.filterdataList.length) {
            const selectedTrip = this.filterdataList.find(
              (x) => x._id === this.selectedTripId
            );
            if (selectedTrip) {
              selectedTrip.loadedMessage = data.message;
            }
          }

          this.selectedTripId = null;
        } else {
          sweetAlert("Error", data.message, "warning", "OK");
        }
      });
  }

  getSelectedTrips() {
    return this.dataList
      .filter((trip) => trip.isSelected);

  }

  group(isNotFromButton?) {
    if (this.filterdataList && this.filterdataList.length) {
      if (!isNotFromButton) {
        this.orderBy =
          this.orderBy === "scheduleTime"
            ? "priorityClient.displayName"
            : "scheduleTime";
      }
      if (this.orderBy === "priorityClient.displayName") {
        this.filterdataList.sort((a, b) =>
          a.priorityClient.displayName.localeCompare(
            b.priorityClient.displayName
          )
        ); // ASC
      } else {
        this.filterdataList.sort(
          (a, b) =>
            <any>new Date(a.scheduleTime) - <any>new Date(b.scheduleTime)
        );
      }
    }
  }
  // Select/Un-Select All & Select Single Trip
  onSelectTrip(trip) {
    const index = this.selectedTrips.indexOf(trip._id);
    if (index > -1) {
      trip.isSelected = false;
      this.selectedTrips.splice(index, 1);
    } else {
      trip.isSelected = true;
      this.selectedTrips.push(trip._id);
    }
  }

  selectAllTrips() {
    this.filterdataList.forEach((assign) => {
      assign.isSelected = true;
      if (!this.selectedTrips.includes(assign._id))
        this.selectedTrips.push(assign._id);
    });
    // }

    this.isAllTripsSelected =
      this.selectedTrips.length === this.filterdataList.length;
    return this.isAllTripsSelected;
  }

  filterTripsByModel() {
    this.filterdataList = this.dataList;
    this.filterdataList = new FilterPipe().transform(
      this.filterdataList,
      this.search
    );
    this.filterTrips();
  }

  filterTrips() {
    this.filterdataList = this.filterdataList.filter(trip => {
      let isDriverExist = true;
      let isCorporateExist = true;
      let islosExist = true;
      let isSpaceTypeExist = true;
      let isServiceAreaExist = true;
      let isAptTypeExist = true;
      let isPatientExist = true;
      let isStaffExist = true;

      if (this.selectedDriver && this.selectedDriver.length) {
        if (trip.driver && trip.driver._id) {
          isDriverExist = this.selectedDriver.includes(trip.driver._id);
        } else {
          isDriverExist = false;
        }
      }

      if (this.selectedStationManager && this.selectedStationManager.length) {
        if (trip.driver && trip.driver.stationManager) {
          isStaffExist = this.selectedStationManager.includes(trip.driver.stationManager);
        } else {
          isStaffExist = false;
        }
      }

      if (this.selectedPatient && this.selectedPatient.length) {
        if (trip.priorityClient && trip.priorityClient.displayName) {
          isPatientExist = this.selectedPatient.includes(trip.priorityClient.displayName);
        } else {
          isPatientExist = false;
        }
      }

      if (this.selectedSpaceType && this.selectedSpaceType.length) {
        if (trip.spaceType) {
          isSpaceTypeExist = this.selectedSpaceType.includes(trip.spaceType);
        } else {
          isSpaceTypeExist = false;
        }
      }

      if (this.selectedAptType && this.selectedAptType.length) {
        if (trip.tripReason) {
          isAptTypeExist = trip.tripReason.some(item => this.selectedAptType.includes(item));
        } else {
          isAptTypeExist = false;
        }
      }

      if (this.selectedCooperate && this.selectedCooperate.length) {
        if (trip.cooperate) {
          isCorporateExist = this.selectedCooperate.includes(trip.cooperate);
        } else {
          isCorporateExist = false;
        }
      }

      if (this.selectedLOS && this.selectedLOS.length) {
        if (trip.los) {
          islosExist = this.selectedLOS.includes(trip.los);
        } else {
          islosExist = false;
        }
      }

      if (this.selectedServiceArea && this.selectedServiceArea.length) {
        if (trip.serviceArea) {
          isServiceAreaExist = this.selectedServiceArea.includes(trip.serviceArea);
        } else {
          isServiceAreaExist = false;
        }
      }


      if (isDriverExist && isStaffExist && isPatientExist && isSpaceTypeExist && isAptTypeExist && isCorporateExist && islosExist && isServiceAreaExist) {
        return true;
      } else {
        return false;
      }
    });
  }

  unSelectAllTrips() {
    const unselectedTrips = [];
    this.filterdataList.forEach((trip) => {
      trip.isSelected = false;
      unselectedTrips.push(trip._id);
    });

    this.selectedTrips = this.selectedTrips.filter(x => !unselectedTrips.includes(x));
    this.isAllTripsSelected = false;
  }

  isStringExist(substrings, str) {
    if (substrings.some((v) => str.toLowerCase().includes(v))) {
      return true;
    }
    return false;
  }

  showFilter() {
    this.showSlideFilter = !this.showSlideFilter;
  }

  closeFilter() {
    this.showSlideFilter = false;
  }

  ngOnDestroy(): void {
    clearInterval(this.settingInterval);
    this.socketService.removeListener(Events.UPDATE_ASSIGN_TRIP);
    this.sharedDataService.toggleDatePicker(false);
  }

  loadedMiles(trip) {
    this.selectedTripId = trip._id;
    const payload = {
      assignId: trip._id,
      isDriveTime: true,
    };
    this.socketService.emit(Events.GET_ASSIGN_TRIP_ETA, payload);
  }

  onClearDriver() {
    this.selectedDriver = "";
  }
  onClearCooperate() {
    this.selectedCooperate = "";
  }

  onClearTripPurpose() {
    this.selectedTripPurpose = "";
  }

  trackByFn(index, item) {
    if (!item) return;
    return item._id; // index or item.id
  }

  getETA(trip) {
    this.assignTripService
      .getETA(trip._id)
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(data => {
        if (data) {
          trip.etaMessage = data.etaMessage;
        }
      });
  }

  tripDetailFile(){
    let selectedTrip;

    if (!this.selectedTrips.length)
      selectedTrip = this.dataList;
    else
      selectedTrip = this.getSelectedTrips();

    this.csvService.generateTripItineraryReport(selectedTrip, this.todayDate, this.timeZone,  this.preCooperates,this.preLevelOfServices,this.preSpaceTypes,this.preServiceAreas)

  }

  driverMonitoringReport() {
    let selectedTrip;

    if (!this.selectedTrips.length)
      selectedTrip = this.dataList;
    else
      selectedTrip = this.getSelectedTrips();

    let filterTrips = selectedTrip.filter(trip => trip.driver && trip.job && ["completed", "finished", "cancelled"].includes(trip.status));

    if (filterTrips && filterTrips.length) {
      this.csvService.driverMonitoringReport(filterTrips, this.todayDate, this.timeZone)
    }
  }

  claimFile(file) {
    let selectedTripIds;

    if (!this.selectedTrips.length)
      selectedTripIds = this.dataList.map((trip) => trip._id);
    else
      selectedTripIds = this.getSelectedTrips().map((trip) => trip._id)

    let payload = {
      // companyType: this.selectedBroker,
      // tempVin: vm.tempVin,
      status: this.status,
      _ids: selectedTripIds,
      scheduleTime: this.todayDate,
      // companyImage: vm.companyImage
    };
    // if (!payload.companyType) {
    //   delete payload.companyType;
    // }

    if (file === "generateExcelFile") {
      this.assignTripService
        .generateTripsReport(payload)
        .pipe(takeUntil(componentDestroyed(this)))
        .subscribe((data) => {
          if (data) {
            let name = data.excelName;
            let url = urls.REPORT_SERVER_URL + "/excel/" + name;
            downloadFile(url, "", name);
          }
        });
    } else if (file === "generateItineraryFile") {
      this.assignTripService
        .generateTripsIntineraryReport(payload)
        .pipe(takeUntil(componentDestroyed(this)))
        .subscribe((data) => {
          if (data) {
            let name = data.excelName;
            let url = urls.REPORT_SERVER_URL + "/excel/" + name;
            downloadFile(url, "", name);
          }
        });
    }
  }

  onDateChange(event) {
    console.log('event', event);
    this.reset();
    this.skip = 0;
    this.clearTrips();
    // this.timeRange = event.toISOString();
    // this.todayDate = event.toISOString();
  this.todayDate = [
      event[0].toISOString(),
      event[1].endOf("day").toISOString(),
    ];
    this.getTrips();
  }

  getFleetList() {
    this.fleetService
      .getFleetList({ 'isFleetSection': true, 'status': 'active' })
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(
        (data) => {
          if (data) {
            this.preFleet = data.reduce((obj, item) => (obj[item._id] = item, obj), {});
          }
        },
        (err) => {
          sweetAlert("Error", err, "error", "OK");
        }
      );
  }

  getDrivers() {
    this.driverService.getDrivers(this.user._id, 'active')
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(
        (data) => {
          if (data) {
            this.preDrivers = data.reduce((obj, item) => (obj[item._id] = item, obj), {});
          }
        },
        (err) => {
          sweetAlert("Error", err, "error", "OK");
        }
      );
  }

  downloadRawReport() {
    const payload = {
      scheduleTime: this.todayDate.toString()
    }
    this.assignTripService.generateRawReport(payload)
      .subscribe(trips => {
        if (trips && trips.length) {

          this.filterRawReportTrips(trips);
        }
      });
  }

  filterRawReportTrips(trips) {
    const selectedTrips = this.getSelectedTrips();
    const filterTrips = this.selectedTrips.length
        ? trips.filter(trip => selectedTrips.some(selected => selected._id === trip._id))
        : trips;

    this.csvService.generateRawTripReport(
        filterTrips,
        this.todayDate,
        this.timeZone,
        this.preCooperates,
        this.preLevelOfServices,
        this.preSpaceTypes,
        this.preServiceAreas,
        this.preFleet,
        this.preDrivers
    );
}

}
